import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const Detail = lazy(() => import('./components/Detail'))
const List = lazy(() => import('./components/List'))
const New = lazy(() => import('./components/New'))
const CommissionPolicies = lazy(() => import('./components/CommissionPolicies'))
const EmployeeList = lazy(() => import('./components/EmployeeList'))

const AffiliateModule: RouteObject = {
    path: 'affiliates',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: 'commission-policies',
            element: <CommissionPolicies />,
        },
        {
            path: 'employees',
            element: <EmployeeList />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AffiliateModule
